<template>
    <div class="pds-content-box mt-5" v-if="entry" itemprop="description">
        <section id="attribute-data-section">
            <h3 class="mb-4">{{ $t('pds.important_data') }}</h3>
            <attribute-data-box
                class="mb-3"
                :entry="entry"
                :is-loading="isLoading"
            ></attribute-data-box>
        </section>

        <ad name="ad_below_product_details" class="mt-3"></ad>

        <section id="top-feature-section" class="mt-5">
            <top-feature-box
                class="mb-3"
                :entry="entry"
                :is-loading="isLoading"
            ></top-feature-box>
        </section>

        <section id="custom-description" v-if="this.entry.custom_description">
            <CustomDescription
                class="mb-3"
                :entry="entry"
                >
            </CustomDescription>
        </section>

        <section id="abo-detail-section" class="mt-5">
            <h3 class="mb-4">{{$t('pds.subscription.details.title')}}</h3>
            <abo-details-box
                class="mb-3"
                :entry="entry"
                :is-loading="isLoading"
            ></abo-details-box>
        </section>

        <section id="environment-consumption-section" class="mt-5 mb-3" v-if="showConsumption">
            <environment-consumption-box
                :entry="entry"
                :is-loading="isLoading"
                class="mb-3"
            ></environment-consumption-box>
        </section>
    </div>
</template>

<script>
import Ad from "../atoms/Ad.vue";
import EnvironmentConsumptionBox from "../molecules/EnvironmentConsumptionBox.vue";
import AboDetailsBox from "../molecules/AboDetailsBox.vue";
import PartnerContactBox from "../molecules/PartnerContactBox.vue";
import TopFeatureBox from "../molecules/TopFeatureBox.vue";
import DeliveryCalculatorBox from "../molecules/DeliveryCalculatorBox.vue";
import AttributeDataBox from "../molecules/AttributeDataBox.vue";
import CustomDescription from "../molecules/CustomDescription.vue";

export default {
    name: 'ProductContentBox',
    components: {
        Ad,
        CustomDescription,
        EnvironmentConsumptionBox,
        AboDetailsBox,
        PartnerContactBox,
        TopFeatureBox,
        DeliveryCalculatorBox,
        AttributeDataBox,
    },
    props: {
        entry: null,
        isLoading: true
    },
    computed: {
        showConsumption() {
            if(this.$root.whitelabel.state.contact.address.country === 'us' || this.entry.category.parent_type == 'Motorbike') {
                return false
            }
            return true
        }
    }
}
</script>
